<template>
  <header class="c-header grid pt-5 pb-4">
    <d-app-bar
      class="c-header__bar lg:hidden"
      :navigation="false"
      appearance="contained"
      scroll="disappears"
    >
      <div class="c-header__menu top-5 flex justify-start items-center">
        <span class="px-1 flex justify-start items-center">
          <c-icon icon="view-list" @click="onNavigation"/>
        </span>
      </div>
      <c-logo class="c-header__logo lg:hidden grow"/>
      <div class="c-header__language flex justify-end lg:justify-center items-center w-8">
        <!--<c-language/>-->
      </div>
    </d-app-bar>
    <div class="c-header__bar--none lg:hidden h-9"/>
    <div class="c-header__breadcrumbs flex items-center pt-4 lg:pt-0">
      <c-breadcrumbs/>
    </div>
  </header>
</template>

<script>
import CBreadcrumbs from '@/components/CBreadcrumbs'
import CIcon from '@/components/CIcon'
// import CLanguage from '@/components/CLanguage'
import CLogo from '@/components/CLogo'
import DAppBar from 'dcode/components/DAppBar'

export default {
  name: 'CHeader',
  components: {
    CBreadcrumbs,
    CIcon,
    // CLanguage,
    CLogo,
    DAppBar
  },
  methods: {
    onNavigation () {
      this.$store.commit('setNavigationStatus')
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
